<app-layout>
    <h1 class="mb-8 font-bold text-3xl">Bank Accounts</h1>
    <div class="mb-6 flex justify-between items-center">
        <nav-button-link :href="route('admin.bank_accounts.create')">
            <span>Add</span>
            <span class="hidden md:inline">&nbsp;new bank account</span>
        </nav-button-link>
    </div>
    <div class="bg-white rounded shadow overflow-x-auto">
        <table class="w-full whitespace-no-wrap">
            <tr class="text-left font-bold">
                <th class="px-6 pt-6 pb-4">Bank Name</th>
                <th class="px-6 pt-6 pb-4">Status</th>
            </tr>
            <tr v-for="account in bankAccounts.data" :key="account.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t">
                    <inertia-link :href="route('admin.bank_accounts.edit', account.id)" class="px-6 py-4 flex items-center text-indigo-500">
                        {{ account.name }}
                    </inertia-link>
                </td>
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center focus:text-indigo-500">
                        <badge class="mr-2" :type="account.status ? 'green' : 'gray'">
                            {{ account.status ? 'Active' : 'Hidden' }}
                        </badge>
                    </span>
                </td>
            </tr>
            <tr v-if="bankAccounts.data.length === 0">
                <td class="border-t px-6 py-2" colspan="100">No Bank Accounts found.</td>
            </tr>
        </table>
    </div>
    <pagination :links="bankAccounts.links" />
</app-layout>
